import { makeStyles } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

export const useStyles = makeStyles({
  dateText: {
    fontSize: customTokens.fontSizeBase200,
    fontWeight: customTokens.fontWeightRegular,
    lineHeight: customTokens.lineHeightBase200,
    whiteSpace: 'nowrap',
  },
});
